export default [
  {
    tech: "react",
    link: "https://reactjs.org/",
  },
  {
    tech: "vue",
    link: "https://vuejs.org/",
  },
  {
    tech: "svelte",
    link: "https://svelte.dev/",
  },
  {
    tech: "html",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    tech: "css",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    tech: "javascript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    tech: "scss",
    link: "https://sass-lang.com/documentation/syntax",
  },
  {
    tech: "tailwindcss",
    link: "https://tailwindcss.com/",
  },
  {
    tech: "redux",
    link: "https://redux.js.org/",
  },
  {
    tech: "jest",
    link: "https://jestjs.io/",
  },
  {
    tech: "npm",
    link: "https://www.npmjs.com/",
  },
  {
    tech: "node.js",
    link: "https://nodejs.org/",
  },
  {
    tech: "docker",
    link: "https://www.docker.com/",
  },
  {
    tech: "express",
    link: "https://expressjs.com/",
  },
  {
    tech: "mongodb",
    link: "https://www.mongodb.com/",
  },
  {
    tech: "cloudinary",
    link: "https://cloudinary.com/",
  },
  {
    tech: "socket.io",
    link: "https://socket.io/",
  },
  {
    tech: "buefy",
    link: "https://buefy.org/",
  },
  {
    tech: "bulma",
    link: "https://bulma.io/",
  },
  {
    tech: "graphql",
    link: "https://graphql.org/",
  },
  {
    tech: "hasura",
    link: "https://hasura.io/",
  },
  {
    tech: "postgresql",
    link: "https://www.postgresql.org/",
  },
  {
    tech: "netlify",
    link: "https://www.netlify.com/",
  },
  {
    tech: "heroku",
    link: "https://www.heroku.com/",
  },
  {
    tech: "firebase",
    link: "https://firebase.google.com/",
  },
  {
    tech: "unity",
    link: "https://unity.com/",
  },
  {
    tech: "c#",
    link: "https://docs.microsoft.com/en-us/dotnet/csharp/",
  },
  {
    tech: "c",
    link: "https://en.wikipedia.org/wiki/C_(programming_language)",
  },
  {
    tech: "c++",
    link: "https://www.cplusplus.com/",
  },
  {
    tech: "webgl",
    link: "https://get.webgl.org/",
  },
  {
    tech: "java",
    link: "https://www.java.com/",
  },
  {
    tech: "eclipse",
    link: "https://www.eclipse.org/ide/",
  },
  {
    tech: "visual studio",
    link: "https://visualstudio.microsoft.com/",
  },
  {
    tech: "photoshop",
    link: "https://www.adobe.com/ca/products/photoshop.html",
  },
  {
    tech: "mips assembly",
    link: "https://en.wikipedia.org/wiki/MIPS_architecture",
  },
  {
    tech: "mars simulator",
    link: "http://courses.missouristate.edu/kenvollmar/mars/",
  },
  {
    tech: "astro",
    link: "https://astro.build/",
  },
  {
    tech: "sanity",
    link: "https://www.sanity.io/",
  },
];
